<template>
  <div>
    <h3 class="header">{{title}}</h3>
    <div class="title">
      <div style="font-size:14px;margin:10px;color:gray">{{desc}}</div>

      <van-cell-group
    
        style="display:flex;align-items:center; "
        v-for="(item,index) in question.linkman"
        :key="index"
      >
        <van-field
          :label="item.showname"
          style="font-size:19px;"
          size="large"
          clearable
          v-model="item.content"
          :placeholder="'请输入'+item.showname"
          :required="item.required"
        />
      </van-cell-group>
      <h5>{{questions}}</h5>
      <div v-for="(item,index) in question.radios" :key="index" style="font-size:18px">
        <!-- <van-radio :required="item.required" :name="item.qid" class="radio"> -->
        {{item.qid}}. {{item.showname}}
        <div style="display:flex;align-items:center;">
          <van-rate
            v-model="item.value"
            allow-half
            void-icon="star"
            void-color="#eee"
            style="margin:5px;"
          />
          <span style="color:gray;font-size:18px">{{item.value}}星</span>
        </div>
        <!-- / <span style="color:gray">{{item.ext}}</span> -->
        <!-- </van-radio> -->
      </div>
      <br />

      <van-cell-group v-for="(item,qid) in question.texts" :key="qid+'1'" style="font-size:18px">
        <div>{{item.qid}}. {{item.showname}}</div>
        <van-field v-model="item.value" style="border:1px solid #C1C1C1" type="textarea" autosize />
      </van-cell-group>
      <br />

      <div style="display:flex;justify-content: center;">
        <van-button type="primary" class="submit" :disabled="disabled" @click="submitAnswer">提交答案</van-button>
      </div>
      <div class="footer">
        <!-- 吉林银行专属客户经理 -->
        <br />
        {{ad}}
        <br />@锐道咨询
      </div>
    </div>
  </div>
</template>

<script>
import { wxzhuzi, wenjuan } from "../api/wenjuan";

export default {
  data() {
    return {
      disabled: false,
      value: 4.5,
      checkbox: [],
      radio: "2",

      title: "",
      questions: "",
      desc: "",
      ad: "",
      question: {
        id: "",
        radios: [],
        texts: [],
        linkman: []
      }
    };
  },
  methods: {
    change(val) {
      this.question.answer = val;
    },
    submitAnswer() {
      this.disabled = true;
      this.question.id = this.$route.query.id;
      this.$http
        .post("/oa/wxdianping/teacher_feedback", this.question)
        .then(res => {
          if (res.data.code == 200) {

            this.$toast({
              message: res.data.message,
              // type: "success",
              duration: 100000
            });
            // window.location.reload();
            this.disabled = true;
          } else {
            this.$toast({
              message: res.data.message,
              type: "waring",
              duration: 3000
            });
            this.disabled = false;
          }
        });
    }
  },
  created() {
    if (this.$route.query.id) {
      var id = this.$route.query.id;

      this.$http.post("/oa/wxdianping/teacher?id=" + id).then(res => {
        const date = res.data.data;
        this.title = date.title;
        this.question.radios = date.radios;
        this.question.texts = date.texts;
        this.question.linkman = res.data.data.linkman;
      });
    } else {
      const id = 2;
      this.$route.query.id = id;
      this.$http
        .post("/oa/wxdianping/teacher?id=" + this.$route.query.id)
        .then(res => {
          const date = res.data.data;
          this.title = date.title;
          this.question.radios = date.radios;
          this.question.texts = date.texts;
          this.question.linkman = res.data.data.linkman;
        });
    }
  }
};
</script>

<style scoped>

.title {
  width: 90%;
  margin: 0 0 0 20px;
  font-size: 14px;
}
.header {
  width: 100%;
  text-align: center;
  margin: 10px 0 0 0;
}
.radio {
  margin: 20px 0 0 0;
}
.submit {
  border-radius: 10px;

  width: 100px;
  height: 40px;
}
.margin {
  margin: 10px;
}
.footer {
  text-align: center;
  color: gray;
  font-size: 16px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/feedback.vue